import { useEffect, useState } from "react";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, brl, errMsg } from "@/lib/api";
import { blueBtn } from "@/components/mobile/parts";
import { cn } from "@/lib/utils";

export function MergeDialog({ open, c, onClose, onDone }) {
  const [list, setList] = useState(null);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setSel([]);
    setList(null);
    api.get("/comandas?status=open").then((r) => setList(r.data.filter((x) => x.id !== c.id))).catch((e) => { toast.error(errMsg(e)); setList([]); });
  }, [open, c.id]);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const merge = async () => {
    setBusy(true);
    try {
      await api.post(`/comandas/${c.id}/merge`, { source_ids: sel });
      toast.success(`${sel.length} comanda(s) agrupada(s) na #${c.number}`);
      onClose();
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-sm overflow-y-auto" data-testid="m-merge-dialog">
        <DialogHeader>
          <DialogTitle>Agrupar na comanda #{c.number}</DialogTitle>
          <DialogDescription>Os itens e pagamentos das comandas escolhidas passam para esta, e elas são encerradas.</DialogDescription>
        </DialogHeader>
        {!list ? <Loader2 className="mx-auto h-6 w-6 animate-spin text-[#1565c0]" /> : (
          <ul className="space-y-2">
            {list.map((x) => {
              const on = sel.includes(x.id);
              return (
                <li key={x.id}>
                  <button onClick={() => toggle(x.id)} className={cn("flex w-full items-center gap-3 rounded-xl border px-3 py-3 text-left text-sm", on ? "border-[#1565c0] bg-[#e3f2fd]" : "border-slate-200")} data-testid={`m-merge-option-${x.number}`}>
                    <span className={cn("grid h-6 w-6 place-items-center rounded-md border-2", on ? "border-[#1565c0] bg-[#1565c0] text-white" : "border-slate-300")}>{on && <Check className="h-4 w-4" />}</span>
                    <span className="flex-1"><b>#{x.number}</b> · {x.customer_name || (x.table_number ? `Mesa ${x.table_number}` : "Sem nome")}</span>
                    <span className="font-mono">{brl(x.total)}</span>
                  </button>
                </li>
              );
            })}
            {!list.length && <p className="py-4 text-center text-sm text-slate-500">Não há outras comandas abertas.</p>}
          </ul>
        )}
        <DialogFooter>
          <Button className={cn("w-full", blueBtn)} disabled={!sel.length || busy} onClick={merge} data-testid="m-merge-confirm-btn">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Agrupar ({sel.length})</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
